// Base URL already includes /api/v1, so paths are relative (see eddEndpoints/screeningEndpoints).
const scoringEndpoints = {
  explain: (businessKey: string) => `/risk-scoring/${businessKey}/explain`,
} as const;

export default scoringEndpoints;
